<template>
  <Menu
    as="div"
    class="relative inline-block text-left !overflow-visible z-backdrop-reset"
    v-if="hasValidOptions"
  >
    <MenuButton
      @click.stop="showMenu = !showMenu"
      v-if="slots.default && slots.default !== ''"
    >
      <slot />
    </MenuButton>
    <MenuButton
      v-else
      @click.stop="showMenu = !showMenu"
      :class="
        !!label
          ? 'border border-transparent bg-brand-900 px-3.5 py-2 hover:bg-brand-800 text-white'
          : 'bg-white border border-gray-300 p-2 hover:bg-gray-50'
      "
      class="disabled:opacity-50 inline-flex justify-center items-center rounded-md text-sm font-medium shadow-sm focus:outline-none sm:text-sm relative z-backdrop-content"
    >
      <template v-if="label">
        {{ label }}
        <ChevronDownIcon class="-mr-1 h-5 w-5 ml-1" aria-hidden="true" />
      </template>
      <template v-else>
        <DotsVertical class="h-5 w-5 text-gray-700" aria-hidden="true" />
      </template>
    </MenuButton>

    <div v-if="showMenu">
      <Backdrop @backdropClicked="showMenu = false" />
      <MenuItems
        static
        class="absolute right-0 top-full z-backdrop-content mt-2 origin-top-right rounded-md bg-white shadow-[0px_4px_6px_-2px_rgba(16,24,40,0.03),0px_12px_16px_-4px_rgba(16,24,40,0.08)] border border-gray-200 ring-opacity-5 focus:outline-none flex flex-col gap-1 min-w-[200px]"
      >
        <div class="relative py-1">
          <template v-for="option in options">
            <MenuItem
              v-if="option.show ? option.show() : true"
              :key="option.key"
              @click.stop="handleOptionClick(option)"
              v-slot="{ active }"
            >
              <div
                class="px-4 py-1.5 pointer"
                :class="active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'"
              >
                <div
                  class="flex gap-2"
                  :class="option.description ? 'items-start' : 'items-center'"
                >
                  <component
                    v-if="option.icon"
                    :is="option.icon"
                    class="w-[18px] h-[18px] text-gray-900 flex-shrink-0"
                    :class="option.description ? 'mt-1' : 'mt-0'"
                  />
                  <div>
                    <span class="block text-sm whitespace-nowrap font-medium">{{
                      option.label
                    }}</span>
                    <p class="text-gray-500 text-xs">
                      {{ option.description }}
                    </p>
                  </div>
                </div>
              </div>
            </MenuItem>
          </template>
        </div>
      </MenuItems>
    </div>
  </Menu>
</template>

<script setup>
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { ChevronDownIcon } from "@heroicons/vue/20/solid";
import { computed, ref, useSlots } from "vue";
import Backdrop from "@/Tailwind/Components/Backdrop.vue";
import DotsVertical from "@/Tailwind/Icon/DotsVertical.vue";

const props = defineProps({
  label: String,
  options: Array,
  eventData: Object,
});

const slots = useSlots();

const showMenu = ref(false);

const handleOptionClick = (option) => {
  showMenu.value = false;
  option.onClick(props.eventData);
};

const hasValidOptions = computed(() => {
  return props.options.some((option) => (option.show ? option.show() : true));
});
</script>
